import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";

const navItems = [
  {
    label: "Home",
    to: "/",
    isActive: (match, location) =>
      location.pathname === "/" || location.pathname === "/home",
  },
  { label: "Education", to: "/education" },
  { label: "Experience", to: "/experience" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" },
];

class Header extends Component {
  render() {
    const link = settings.isSplash ? "/splash" : "/";
    return (
      <Fade top duration={1000} distance="20px">
        <SeoHeader />
        <div className="header-shell">
          <header className="header">
            <NavLink to={link} className="logo" aria-label="Home">
              <span className="logo-mark">&lt;/&gt;</span>
              <span className="logo-name">{greeting.logo_name}</span>
            </NavLink>
            <input className="menu-btn" type="checkbox" id="menu-btn" />
            <label className="menu-icon" htmlFor="menu-btn" aria-label="Open menu">
              <span className="navicon"></span>
            </label>
            <ul className="menu">
              {navItems.map((item) => {
                return (
                  <li key={item.label}>
                    <NavLink
                      to={item.to}
                      exact={item.to === "/"}
                      isActive={item.isActive}
                      activeClassName="active-nav-link"
                    >
                      {item.label}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </header>
        </div>
      </Fade>
    );
  }
}
export default Header;
